/* app-cart-tracking.js
 * Injects hidden cart attribute inputs into Shopify checkout forms when the
 * page is loaded inside the MobiLoud Canvas app. No-ops on all other contexts.
 *
 * Attributes added:
 *   attributes[_order_source] = mobiloud_app
 *   attributes[_app_platform] = ios | android | unknown
 *
 * No /cart/update.js calls. No fetch. No checkout blocking.
 * Uses form submit and click capture (useCapture = true) so the inputs are
 * always present when Shopify receives the POST, even after cart re-renders.
 */
(function () {
  var root = document.documentElement;

  function isMobiLoudApp() {
    return root.classList.contains('is-mobiloud-app');
  }

  function getAppPlatform() {
    if (root.classList.contains('is-ios-app'))     return 'ios';
    if (root.classList.contains('is-android-app')) return 'android';
    return 'unknown';
  }

  function ensureHiddenInput(form, name, value) {
    if (!form) return;
    var existing = form.querySelector('input[name="' + name + '"]');
    if (!existing) {
      existing = document.createElement('input');
      existing.type = 'hidden';
      existing.name = name;
      form.appendChild(existing);
    }
    existing.value = value;
  }

  function markFormAsAppOrder(form) {
    if (!form) return;
    ensureHiddenInput(form, 'attributes[_order_source]', 'mobiloud_app');
    ensureHiddenInput(form, 'attributes[_app_platform]', getAppPlatform());
  }

  function isCheckoutForm(form) {
    return !!(form && (form.id === 'CartDrawer-Form' || form.id === 'cart'));
  }

  if (!isMobiLoudApp()) return;

  /* Capture phase submit — fires before the form data is collected, ensuring
     the hidden inputs are included in the POST body sent to Shopify. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (isCheckoutForm(form)) {
      markFormAsAppOrder(form);
    }
  }, true);

  /* Capture phase click — handles the case where a button.form attribute
     points to a form ID (cart page #checkout button uses form="cart").
     Runs before the submit event so inputs are present. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest
      ? event.target.closest('#CartDrawer-Checkout, #checkout')
      : null;
    if (!button) return;
    var form = button.form ||
      (button.getAttribute('form') && document.getElementById(button.getAttribute('form')));
    if (isCheckoutForm(form)) {
      markFormAsAppOrder(form);
    }
  }, true);
})();
